import { useEffect, useState } from "react";
import { FormInput } from "../../../shared/components/form-component/form-input";
import { CustomLoader } from "../../../shared/components/custom-loader/custom-loader";
import ErrorBoundary from "../../../shared/components/error-boundary/error-boundary";
import { SERVICES } from "app/core/services/services";
import { CustomToast } from "app/shared/components/alert/custom-toast";
import { Optional } from "app/shared/components/optional/optional";
import { HELPER } from "app/shared/helper/helper";

export function AccountInformation({ accountNumber, closeModal }) {
  const [loading, setLoading] = useState(false);
  const [accountInfo, setAccountInfo] = useState({
    accountNumber: "",
    accountName: null,
  });
  const [errorMessage, setErrorMessage] = useState(null);

  useEffect(() => {
    function getAccountInformation() {
      setLoading(true);
      SERVICES.VERIFY_ACCOUNT_NUMBER(accountNumber)
        .then((data) => {
          setAccountInfo({
            accountNumber,
            accountName: data?.result?.accountName,
          });
          setLoading(false);
        })
        .catch((error) => {
          setErrorMessage(HELPER.PROCESS_ERROR(error));
          setLoading(false);
        });
    }
    getAccountInformation();
  }, [accountNumber]);

  const cancelButton = () => {
    if (!loading) {
      return (
        <button onClick={closeModal} className="primary-button">
          Close
        </button>
      );
    } else {
      return <div />;
    }
  };

  const accountInformationView = () => {
    return (
      <div className="account-information">
        <div className="">
          <p className="custom-modal-title p-text-left p-mt-0">
            Account Information
          </p>
        </div>
        <div className="custom-dialog-subtitle-container-lg">
          <p className="custom-dialog-subtitle p-mb-4">
            View account information below
          </p>
        </div>
        <div className="p-grid p-text-left">
          <div className="p-col-12">
            <FormInput
              value={accountInfo["accountNumber"]}
              disabled={true}
              placeholder="Account Number"
            />
          </div>
          <div className="p-col-12">
            <FormInput
              value={accountInfo["accountName"]}
              disabled={true}
              placeholder="Account Name"
            />
          </div>
          <Optional show={errorMessage}>
            <div className="p-col-12">
              <CustomToast
                title={"Error"}
                description={errorMessage}
                type="error"
              />
            </div>
          </Optional>
          <div className="p-col-12 p-mt-5">
            <div className="p-grid">
              <div className="p-col-12">{cancelButton()}</div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <ErrorBoundary>
      {loading ? (
        <div className="p-mt-2 p-text-center">
          <CustomLoader loadingText="Getting account information..." />
        </div>
      ) : (
        <div className="p-pb-5">{accountInformationView()}</div>
      )}
    </ErrorBoundary>
  );
}
